<template>
  <div id="pbn-filters">
    <div class="search col-lg-12">
      <div class="col-lg-3">
        <div class="col-lg-3"><label>From:</label></div>
        <div class="col-lg-9">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="col-lg-3"><label>To:</label></div>
        <div class="col-lg-9">
        </div>
      </div>
      <div class="col-lg-3">
        <div class="col-lg-3"><label>By:</label></div>
        <div class="col-lg-9">
        </div>
      </div>
    </div>
    <div class="search col-lg-12 m-t-sm">
      <div class="col-lg-3">
        <div class="col-lg-3"><label>Actions:</label></div>
        <div class="col-lg-9">
        </div>
      </div>
    </div>
    <div class="col-lg-12 m-t-sm">
      <button class="btn btn-xs btn-primary" @click="loadReport">Generate</button>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import { REPORT_SET } from '../../../../../store/mutation-types'

export default {
  data () {
    return {
      filters: {
      },
      meta: {
        count: 0,
        resultCount: 0
      },
      report: [],
      summary: {},
      multiFilters: {},
      actionFilters: {}
    }
  },
  computed: {
    ...mapGetters({
      f: 'getFilters'
    })
  },
  mounted () {
    if (!this.f.clients) {
      this.$store.dispatch('loadFilters')
    }
  },
  methods: {
    loadReport () {
      axios.get('/pbn/builds/report')
        .then(r => {
          this.$store.commit(REPORT_SET, r.data)
        }).catch(e => {
          this.$toastr.error(e, 'I\'m just a poor report nobody likes me :(')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/Report/Filters.vue